import React from 'react';
import { Switch, Button, ActionsButtons } from 'components';
import styles from 'styles/items_list.module.scss';
import get from 'lodash/get';
import classNames from 'lib/classNames';

const Item = (props) => {
	const { item, actions, header } = props;
	return (
		<tr className={styles.item}>
			{header.map((cell) => {
				switch (cell.title) {
					case 'Active':
						return (
							<td key={`Status-${item.id}`}>
								<div>
									<Switch value={item.active} onChange={(status) => cell.onChange(item, status)} />
								</div>
							</td>
						);

					case 'Created At':
						return (
							<td key={`${cell.title}-${item.id}`}>
								<div className={classNames('flex-center')}>
									{new Date(parseInt(item[cell.value])).toDateString()}
								</div>
							</td>
						);

					case 'Updated At':
						return (
							<td key={`${cell.title}-${item.id}`}>
								<div className={classNames('flex-center')}>
									{new Date(parseInt(item[cell.value])).toDateString()}
								</div>
							</td>
						);

					case 'Actions':
						return (
							<td key={`${cell.title}-${item.id}`}>
								<div className={classNames('flex-center')}>
									<ActionsButtons {...{ item, actions }} />
								</div>
							</td>
						);

					default:
						return (
							<td key={`${cell.title}-${item.id}`}>
								<div>{getValue(item, cell)}</div>
							</td>
						);
				}
			})}
		</tr>
	);
};

const getValue = (item, cell) => {
	if (cell.value instanceof Function) return cell.value(item);
	return get(item, cell.value || cell.title.toLowerCase());
};

export default Item;
